import NeighborhoodPageContent from "../NeighborhoodPageContent";

export default function CarreteraDeCadiz() {
  return <NeighborhoodPageContent slug="carretera-de-cadiz" />;
}